module.exports = __webpack_public_path__ + "static/media/dioxido.213c2f08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/dioxido.svg
// module id = 1131
// module chunks = 0